import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";

import { ViewerService } from "../service/api/viewer.service";
import { viewerInterface } from "../viewer.interface";
import { SessionService } from "./../../common/services/session.service";

@Component({
  selector: "app-viewer-list",
  templateUrl: "./viewer-list.component.html",
  styleUrls: ["./viewer-list.component.scss"],
})
export class ViewerListComponent implements OnInit {
  viewerData: any[];
  viewerObj: viewerInterface;
  userRoleFlag: boolean = false;
  officeData: any;
  userInfo: any;
  isPagination: boolean = true;
  totalCount: any;
  search = "";
  cols: any;
  deleteData: any;
  dialougFlag: boolean = false;
  config: any;
  entityName: string = "profileImage";
  lastDeletedRecord: any = null;
  restoreDialogFlag = false;


  constructor(
    private viewerService: ViewerService,
    private ss: SessionService,
    private toast: MessageService,
    private router: Router
  ) {}

  opendialoug(obj) {
    this.dialougFlag = true;
    this.deleteData = obj;
  }
  //soft Delete Call
  deleteRecord(viewerData) {
    viewerData.recordStatus = "DELETED";
    this.viewerService.updateData(viewerData).subscribe((res) => {
      this.dialougFlag = false;
      this.toast.add({
        severity: "error",
        summary: "Deleted Successfully",
        detail: "Viewer Entry Deleted successfully !!!",
      });
    });
  }

  getViewerList() {
    this.viewerService.getViewerData().subscribe((data: any) => {
      this.viewerData = data;
    });
  }

  editViewer(viewerData) {
    let viewerId = viewerData ? viewerData.id : null;
    this.router.navigate(["/user/viewer/edit/" + viewerId]);
  }

  deleteViewer(id) {
    this.viewerService.deleteVidewer(id).subscribe((resp) => {});
  }

  getTotalCount() {
    this.viewerService.totalCount().subscribe((res: any) => {
      this.totalCount = res;
    });
  }

  getPageConfig() {
    this.viewerService.getPageConfig().subscribe((res) => {
      this.config = res;
    });
  }

  handleEvent(event) {
    /* if (event.name == "LAZY_LOAD") {
      this.getViewerList();
    } */
  }

  ngOnInit() {
    this.getTotalCount();
    this.getPageConfig();
    this.getViewerList();
    this.userInfo = this.ss.getUserInfo();
    if (this.userInfo.role === "VIEWER") {
    } else {
      this.officeData = this.ss.getOffice();
    }
  }
  onUndo(event: Event, rowData: any) {  
    rowData.recordStatus = 'ACTIVE';  
      rowData.deleted = true;   
      this.restoreData(rowData);
  }
  
  restoreData(rowData: any) {
    if (!this.restoreData) return;
    this.viewerService.restoreRecord(rowData).subscribe(
      (resp) => {
        this.restoreDialogFlag = true;
        console.log('Record restored successfully:', resp);
        // this.setStatusData({ index: parseInt(this._index, 10) });
        
        this.toast.add({
          severity: 'success',
          summary: 'Restored Successfully',
          detail: 'The record has been successfully restored.',
        });
      },
          (error) => {
            console.error('Error restoring data:', error);
            this.toast.add({
              severity: 'error',
              summary: 'Error Restoring Record',
              detail: 'There was an error while restoring the record.',
            });
          }
    );
  }

}
